import type { IconData } from '@stacksjs/iconify-core'

export const camera: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M471.993 112h-89.2l-16.242-46.75a32.02 32.02 0 0 0-30.229-21.5H175.241a31.99 31.99 0 0 0-30.294 21.691L129.1 112H40a24.027 24.027 0 0 0-24 24v312a24.027 24.027 0 0 0 24 24h431.993a24.027 24.027 0 0 0 24-24V136a24.027 24.027 0 0 0-24-24m-8 328H48.007V144h104.01l23.224-68.25h161.081l23.71 68.25h103.961Z\"/><path fill=\"currentColor\" d=\"M256 168a114 114 0 1 0 114 114a114.13 114.13 0 0 0-114-114m0 196a82 82 0 1 1 82-82a82.093 82.093 0 0 1-82 82\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default camera
